// @flow

import React, { useMemo } from 'react';
import styled from 'styled-components';

import { AbsoluteBackground } from 'components/Gui';
import { Color, Transition } from 'styles';
import { useNavState, usePageState } from 'contexts';

const Wrapper = styled(AbsoluteBackground)`
  transition: opacity ${Transition.DEFAULT};
  opacity: ${({ showing }) => (showing ? 0.9 : 1)};
  background: ${Color.BLACK};
`;

const Background = () => {
  const { atTop } = useNavState();
  const {
    headerConfig: { noOpacityTransition },
  } = usePageState();
  return useMemo(() => <Wrapper noOpacityTransition={noOpacityTransition} showing={!atTop} />, [atTop, noOpacityTransition]);
};

export default Background;
